module.exports = __webpack_public_path__ + "img/img-noData.bbad49d4.png";